import { createUploadLink } from "apollo-upload-client";
import { config } from "../config";

export const uploadLink = createUploadLink({
  uri: `${config.serverUrl}${config.grahpqlPath}`,
  credentials: "same-origin",
});
